const Warning = ({ ...props }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 26 23"
            {...props}
            width="24"
            height="21"
        >
            <path
                fill="#E2A426"
                d="M.121 22.55h25.758a.121.121 0 00.105-.182L13.104.06a.12.12 0 00-.209 0L.016 22.368a.12.12 0 00.105.181zM13 2.82l10.542 18.259H2.458L13 2.819z"
            />
            <path fill="#E2A426" d="M1 22L13 1l12 21H1z" />
            <path
                fill="#fff"
                d="M12.386 7.663h1.228a.121.121 0 01.121.12v8.122a.121.121 0 01-.12.12h-1.23a.121.121 0 01-.12-.12V7.784a.12.12 0 01.12-.121zM13.614 17.448h-1.228a.12.12 0 00-.121.12v1.64c0 .067.054.122.12.122h1.23a.12.12 0 00.12-.121v-1.64a.12.12 0 00-.12-.121z"
            />
        </svg>
    )
}

export default Warning
